import(/* webpackMode: "eager" */ "/vercel/path0/app/[locale]/legal/terminos/page.jsx");
